import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Lokka from 'lokka';
import LokkaTransport from 'lokka-transport-http';

import AdminStore from '@/store/admin';
import AuthStore from '@/store/auth';
import MapStore from '@/store/map';
import StatisticStore from '@/store/statistic';
import DataStore from '@/store/data';
import MobileStore from '@/store/mobile';
import FileStore from '@/store/files';
import CompanyStore from '@/store/company';
import ProjectStore from '@/store/project';
import SupportTicketStore from '@/store/support_ticket';
import RoleStore from '@/store/role';
import AppointmentStore from '@/store/appointment';

Vue.use(Vuex);

function createClient(token) {
	return new Lokka({
		transport: new LokkaTransport('/graphql', {
			headers: {
				Authorization: `Bearer ${token}`
			},
		})
	});
}
let tempClient = createClient('doorkeeper');

export let client = {
	query: (...args) => {
		return tempClient.query(...args).catch(error => {
			if(error.hasOwnProperty('rawError') && error.rawError.length > 0 && error.rawError[0].hasOwnProperty('message') && error.rawError[0].message === 'You must be logged in to access this resource') {
				// user is nog signed in anymore
				window.location.reload();
			}
			throw error;
		});
	}
}

export default new Vuex.Store({
	modules: {
		admin: AdminStore,
		auth: AuthStore,
		map: MapStore,
		statistic: StatisticStore,
		data: DataStore,
		mobile: MobileStore,
		files: FileStore,
		companies: CompanyStore,
		projects: ProjectStore,
		support_tickets: SupportTicketStore,
		roles: RoleStore,
		appointments: AppointmentStore
	},

	state: {
		// general
		config: null,
		loading: false,
		ready: false,

		// shared component state
		activeDropdown: null,
	},

	// sync actions
	mutations: {
		setConfig(state, value) {
			state.config = value;
			tempClient = createClient(state.config.graphql_bearertoken);
		},

		setLoading(state) {
			state.loading = true;
		},

		setIdle(state) {
			state.loading = false
		},

		setActiveDropdown(state, value) {
			state.activeDropdown = value;
		},

		setReady(state) {
			state.ready = true;
		},
	},

	// async actions
	actions: {
		loadConfig({ commit, state }) {
			return new Promise((resolve, reject) => {
				axios.get('/tokens').then(response => {
					if (!response.data.error) {
						commit('setConfig', response.data);
						resolve();
					} else {
						reject();
					}
				});
			});
		},
	}
})
